import { takeLatest } from 'redux-saga/effects';
import {
    ADD_SALARY_ADVANCE,
} from '../../redux/modules/salaryAdvance/salaryAdvance-actions';
import addAdvancedSalary from './advanceSalaryWorker';

export default function* createAdvancedSalary() {
    yield takeLatest(ADD_SALARY_ADVANCE, addAdvancedSalary);
}
